import React from 'react';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../../fx/FxLog';
import * as FxFetch from '../../../fx/FxFetch';
import { useTranslation } from '../../../hx/useTranslation';
import CxDialog from '../../../cx/CxDialog';
import CxInput from '../../../cx/CxInput';
import CxSnackbar from '../../../cx/CxSnackbar';
import CxDlgAlert from '../../../cx/CxDlgAlert'; // Importación necesaria
import '../../../../styles/main.css';


const MxProfOTF = (props) => {
  const [{ trans }] = useTranslation();
  const [dlg, setDlg] = React.useState(false);
  const [disabled, setDisabled] = React.useState(false);

  const rf_txProf = React.useRef(null);
  const rf_txLicense = React.useRef(null);

  const r_dlg_alert = React.useRef(null); // Referencia para la alerta
  const r_snack_required = React.useRef(null);
  const r_snack_exists = React.useRef(null);

  React.useEffect(() => {
    formLoad();
    // eslint-disable-next-line
  }, []);

  // para poder usar setVal desde el parent component con ref.current
  React.useImperativeHandle(props.xref, () => {
    return {
      setDlg,
    };
  });

  const formLoad = async () => {
  }

  const formSave = async () => {
    // chequea requeridos
    if (rf_txProf.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txProf.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }

    // --- PROCESO DE GUARDADO ---
    setDlg(false); // Ocultamos el diálogo principal
    setDisabled(true);

    r_dlg_alert.current.setText(trans('msg.saving'));
    r_dlg_alert.current.setProgressMsg(trans('msg.please_wait'));
    r_dlg_alert.current.setTextColor('var(--ibs_color_blue)');
    r_dlg_alert.current.setHasButtonClose(false);
    r_dlg_alert.current.setOpen(true);

    let txProf = rf_txProf.current.getVal();
    let txLicense = rf_txLicense.current.getVal();

    let record = {};
    record['txProf'] = txProf;
    record['txLicense'] = txLicense;

    Promise.all([FxFetch.doJsonX("profs/otf", record)]).then((result) => {
      r_dlg_alert.current.setOpen(false); // Cerramos el aviso de espera

      if (result[0]) {
        if (result[0].theValue === null) {
          // Ya existe: reabrimos formulario
          setDisabled(false);
          setDlg(true);
          r_snack_exists.current.setVal(trans('msg.x_exists', 'field.professional'));
          r_snack_exists.current.setOpen(true);
        } else {
          // Éxito: simplemente notificamos al padre
          let inProf = result[0].theValue;
          if (props.onOk) props.onOk(inProf, txProf);
          setDisabled(false);
        }
      }
    }).catch((error) => {
      // Error técnico: reabrimos formulario
      r_dlg_alert.current.setOpen(false);
      setDisabled(false);
      setDlg(true);
      FxLog.errorx("MxProfOTF.formSave", error);
    });
  }

  return (
    <div>
      <CxDialog title={trans('field.create_x', 'field.professional')} open={dlg} onOk={formSave} onClose={() => setDlg(false)} >
        <CxInput xref={rf_txProf} label={trans('field.professional')} disabled={disabled} width='var(--ibs_control_width_md)' maxLength={100} required />
        <CxInput xref={rf_txLicense} label={trans('field.license')} disabled={disabled} width='var(--ibs_control_width_md)' maxLength={15} />
      </CxDialog>

      <CxDlgAlert xref={r_dlg_alert} />

      <CxSnackbar xref={r_snack_required} severity="error" />
      <CxSnackbar xref={r_snack_exists} severity="error" />
    </div>
  );

}

export default MxProfOTF;